var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.percenNum!=0 && _vm.percenNum!=100)?_c('div',{staticClass:"fiexd_progress"},[_c('el-progress',{attrs:{"text-inside":true,"stroke-width":20,"percentage":_vm.percenNum}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }